import { ChangeEventHandler, HTMLAttributes, MouseEventHandler, useRef } from 'react';
import classNames from 'classnames';
import st from './CheckBox.module.scss';

interface CheckBoxProps extends HTMLAttributes<HTMLInputElement> {
	/** Наименование поля ввода ( для форм ) */
	name: string;
	/** Инвертировать  */
	// invert?: boolean;
	/** Доступность инпута */
	disabled?: boolean;
	/** Значение инпута */
	value?: boolean;
	/** Заголовок инпута */
	label?: string;
	/** Растянуть на всю ширину */
	isBlock?: boolean;
	/**  */
	inline?: boolean;
	/**  */
	invert?: boolean;
	/** Установка значения */
	onChangeValue?: ( value: boolean ) => void;
};

/** Компонента чекбокса */
const CheckBox: React.FC<CheckBoxProps> = (props) => {
	
	const { name, label, title, value, onChangeValue, children, isBlock = false, disabled = false, inline, invert,
		className, ...otherProps 
	} = props;

	/** Обработка клика по инпуту */
	const onChangeValueHandler: ChangeEventHandler<HTMLInputElement> = ( e ) => {
		if ( !!onChangeValue ) {
			onChangeValue( !!e.target.checked );
		}
	};

	/** Отрисовка заголовка чекбокса */
	const renderLabel = () => {
		if ( !children && !label ) return null;
		return (
			<label 
				htmlFor={"cb_" + name} 
				className={ !!children ? st.labelAsContainer : '' }
			>
				{ !!children ? children : label }
			</label>
		);
	};

	const wrapperClasses = classNames( st.checkbox, className, {
		[st.disabled]: disabled,
		[st.inline]: inline,
		[st.invert]: invert
	});

	return (
		<div className={wrapperClasses} title={title} hidden={otherProps.hidden}>
			<input
				{ ...otherProps }
				id={"cb_" + name}
				name={name}
				type="checkbox" 
				checked={!!value}
				onChange={onChangeValueHandler}   
				disabled={disabled}
			/>
			{ renderLabel() }
		</div>
	);
};

export default CheckBox;
